import AppliedTalent from "../../components/employeer/applied-talent";

const ApplicantEmployeerPage = () => {
  return <AppliedTalent />;
};

export default ApplicantEmployeerPage;
